import axios from "axios";
import Moment from "moment";
import { useEffect, useMemo, useState } from "react";
import { FaCheckCircle } from "react-icons/fa";
import { MdContentCopy } from "react-icons/md";
import Actions from "../../../../components/Common/Actions";
import AntdBreadcrumbs from "../../../../components/Common/Breadcrumbs/AntdBreadcrumbs";
import CommonFIlterModal from "../../../../components/Common/CommonFilterModal";
import DoctorsFilterOptions from "../../../../components/Common/CommonFilterOptions";
import ListPageLayout from "../../../../components/Layout";
import AssignedTo from "../../../../components/Modal/AssignedTo";
import Deletepopup from "../../../../components/Modal/Deletepopup";
import LeadStatus from "../../../../components/Modal/LeadStatus";
import LeadStatusConfirm from "../../../../components/Modal/LeadStatusConfirm";
import SucessModal from "../../../../components/Modal/SucessModal";
import useDebouncedSearch from "../../../../components/Utils/hooks/useDebouncedSearch";
import useDeleteHandler from "../../../../components/Utils/hooks/useDeleteHandler";
import usePageChange from "../../../../components/Utils/hooks/usePageChange";
import usePaginatedData from "../../../../components/Utils/hooks/usePaginatedData";
import useSortHandler from "../../../../components/Utils/hooks/useSortHandler";
import "../healthsy-pharmacy.scss";
import { ConcernDetailsModal } from "../utils";
import { Modal, Input, Button, message } from "antd";
import { IoCloseCircleOutline } from "react-icons/io5";

function capitalizeFirstLetter(str) {
  if (!str) return "";
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
}

const emptyFilterValues = {
  "Lead Status": [],
  // "Registered At": [],
};

function SendMailModal({ visible, onCancel, onSend, to }) {
  const [subject, setSubject] = useState("");
  const [body, setBody] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSend = async () => {
    setLoading(true);
    await onSend({ to, subject, body });
    setLoading(false);
  };

  useEffect(() => {
    if (visible) {
      setSubject("");
      setBody("");
    }
  }, [visible]);

  return (
    <Modal
      title="Send Email"
      open={visible}
      onCancel={onCancel}
      footer={[
        <Button key="cancel" onClick={onCancel}>
          Cancel
        </Button>,
        <Button
          key="send"
          type="primary"
          loading={loading}
          onClick={handleSend}
        >
          Send
        </Button>,
      ]}
      closeIcon={<IoCloseCircleOutline size={24} />}
      centered
    >
      <div style={{ marginBottom: 20 }}>
        <label>To</label>
        <Input value={to} disabled />
      </div>
      <div style={{ marginBottom: 20 }}>
        <labe style={{ marginBottom: 25 }}>Subject</labe>
        <Input
          value={subject}
          onChange={(e) => setSubject(e.target.value)}
          placeholder="Type here"
        />
      </div>
      <div>
        <Input.TextArea
          rows={6}
          value={body}
          onChange={(e) => setBody(e.target.value)}
          placeholder="Type here"
        />
      </div>
    </Modal>
  );
}

function CallModal({ visible, onCancel, name, mobile }) {
  const [copied, setCopied] = useState(false);

  const handleCopy = () => {
    navigator.clipboard.writeText(mobile);
    setCopied(true);
    setTimeout(() => setCopied(false), 1000);
  };

  useEffect(() => {
    if (visible) setCopied(false);
  }, [visible]);

  return (
    <Modal
      title={capitalizeFirstLetter(name)}
      open={visible}
      onCancel={onCancel}
      footer={null}
      closeIcon={<IoCloseCircleOutline size={24} />}
      centered
      width={340}
    >
      <div className="hp-mobile-row hp-call-modal-content">
        <div>Mobile Number</div>
        <div className="hp-call-modal-body hp-copy-btn" onClick={handleCopy}>
          <strong>{mobile}</strong>
          {copied ? (
            <FaCheckCircle className="hp-check-icon" />
          ) : (
            <MdContentCopy className="hp-copy-icon" />
          )}
        </div>
      </div>
    </Modal>
  );
}

export default function FranchiseContactUsList({
  cityParam = "skip others",
  deletePath = "healthsy-pharmacy/franchise",
  pagePath = "/franchise-programme/contact-us",
  breadcrumbSecond = "Contact Us",
  withSearchText = false,
}) {
  const [sort, setSort] = useState("newest");
  const [sortName, setSortName] = useState("Sort by");
  const handleSortClick = useSortHandler(setSort, setSortName);

  const [isModalVisible, setIsModalVisible] = useState(false);
  const [modalData, setModalData] = useState(null);
  const [search, setSearch] = useState("");
  const debouncedSearch = useDebouncedSearch(setSearch, () => {
    setPagination((prev) => ({ ...prev, skip: 0, currentPage: 1 }));
  });

  const [leadStatus, setLeadStatus] = useState([]);
  const [bdModal, setBdModal] = useState([]);
  const [selectedValues, setSelectedValues] = useState(emptyFilterValues);
  const [selectedCategory, setSelectedCategory] = useState("Lead Status");
  const [isFilterModalVisible, setIsFilterModalVisible] = useState(false);
  const [tempSelectedValues, setTempSelectedValues] =
    useState(emptyFilterValues);

  const [showDelete, setShowDelete] = useState(false);
  const [assignModal, setAssignModal] = useState({ id: "", status: false });
  const [leadStatusModal, setLeadStatusModal] = useState({
    id: "",
    status: false,
  });
  const [success, setSuccess] = useState(false);
  const [leadStatussuccess, setLeadStatusSuccess] = useState(false);
  const [loader, setLoader] = useState(true);
  const [leadStatusConfirmModal, setLeadStatusConfirmModal] = useState({
    leadType: "",
    status: false,
    id: "",
  });
  const [deleteId, setDeleteId] = useState("");
  const [mailModal, setMailModal] = useState({ visible: false, to: "" });
  const [callModal, setCallModal] = useState({
    visible: false,
    name: "",
    mobile: "",
  });

  const initialParams = useMemo(() => {
    const base = {
      sort,
      city: cityParam,
      ...selectedValues,
    };
    if (withSearchText) base.searchText = search;
    return base;
  }, [sort, cityParam, selectedValues, withSearchText, search]);

  const { records, totalCount, pagination, setPagination, fetchData } =
  usePaginatedData({
    apiUrl: `${process.env.REACT_APP_API_URL}healthsy-pharmacy/franchise/list`,
    initialParams,
  });

  const [copiedData, setCopiedData] = useState({});

  const handleDelete = useDeleteHandler(deletePath, fetchData, setShowDelete);

  const handleCopy = (type, text, id) => {
    navigator.clipboard.writeText(text);
    setCopiedData((prevState) => ({
      ...prevState,
      [id]: {
        ...prevState[id],
        [type]: true,
      },
    }));
    setTimeout(() => {
      setCopiedData((prevState) => ({
        ...prevState,
        [id]: {
          ...prevState[id],
          [type]: false,
        },
      }));
    }, 1000);
  };

  const handlePageChange = usePageChange(pagination, setPagination);

  const successModalClose = () => {
    setSuccess(false);
    setLeadStatusSuccess(false);
  };

  const handleSendMail = async ({ to, subject, body }) => {
    try {
      await axios.post(`${process.env.REACT_APP_API_URL}send-email`, {
        to,
        subject,
        body,
      });
      message.success("Email sent!");
      setMailModal({ visible: false, to: "" });
    } catch (err) {
      message.error("Failed to send email.");
    }
  };

  const fetchAndMap = async (url, mapFn) => {
    try {
      const { data } = await axios.post(
        `${process.env.REACT_APP_API_URL}${url}`,
        { noLimit: true }
      );
      return data?.rows?.map(mapFn) || [];
    } catch (error) {
      console.error(`Error fetching ${url}:`, error);
      return [];
    }
  };

  useEffect(() => {
    if (!assignModal.status && !leadStatusModal.status) setLoader(true);
    fetchData();
    //eslint-disable-next-line
  }, [
    pagination.skip,
    pagination.limit,
    sort,
    search,
    selectedValues,
    success,
    leadStatussuccess,
  ]);

  useEffect(() => {
    records && setTimeout(() => setLoader(false));
  }, [records]);

  useEffect(() => {
    const fetchData = async () => {
      const [leadStatuses, bdModals] = await Promise.all([
        fetchAndMap("healthsy-pharmacy/lead_status/list", (lead) => lead?.type),
        // fetchAndMap("healthsy-pharmacy/bd/list", (data) => data?.bd_name),
      ]);
      setLeadStatus(leadStatuses);
      // setBdModal(bdModals);
    };
    fetchData();
  }, []);

  const columns = [
    {
      title: "S.No",
      dataIndex: "sno",
      key: "sno",
      fixed: "left",
      render: (text, record, index) =>
        Number(pagination.skip || 0) + (index + 1),
    },
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      fixed: "left",
      width: 250,
      render: (text) => capitalizeFirstLetter(text),
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
      width: 250,
      render: (text, record) => {
        const isCopied = copiedData[record._id]?.email;
        return (
          <div className="hp-email-col">
            <div className="hp-email-row">
              <span>{text}</span>
              <div
                className="hp-copy-btn"
                onClick={() => handleCopy("email", text, record._id)}
              >
                {isCopied ? (
                  <FaCheckCircle className="hp-check-icon" />
                ) : (
                  <MdContentCopy className="hp-copy-icon" />
                )}
              </div>
            </div>
            <button
              className="hp-send-mail-btn"
              onClick={() => setMailModal({ visible: true, to: text })}
            >
              Send Mail
            </button>
          </div>
        );
      },
    },
    {
      title: "Mobile No",
      dataIndex: "mobile",
      key: "mobile",
      render: (text, record) => {
        const isCopied = copiedData[record._id]?.mobile;
        return (
          <div className="hp-mobile-col">
            <div className="hp-mobile-row">
              <span>{text}</span>
              <div
                className="hp-copy-btn"
                onClick={() => handleCopy("mobile", text, record._id)}
              >
                {isCopied ? (
                  <FaCheckCircle className="hp-check-icon" />
                ) : (
                  <MdContentCopy className="hp-copy-icon" />
                )}
              </div>
            </div>
            <button
              className="hp-call-btn"
              onClick={() =>
                setCallModal({
                  visible: true,
                  name: capitalizeFirstLetter(record.name),
                  mobile: text,
                })
              }
            >
              Call
            </button>
          </div>
        );
      },
    },
    {
      title: "City / Town",
      dataIndex: "city",
      key: "city",
      width: 400,
      render: (text, record) => (
        <div className="hp-city-row">
          <div className="hp-city-content">
            {capitalizeFirstLetter(record?.city)}
          </div>
        </div>
      ),
    },
    {
      title: "Pincode",
      dataIndex: "pincode",
      key: "pincode",
      render: (text, record) => (
        <div className="hp-pincode-row">
          <span>{record.pincode}</span>
        </div>
      ),
    },
    {
      title: "Assigned To",
      dataIndex: "assigned_to",
      key: "assigned_to",
    },
    {
      title: "Lead Status",
      dataIndex: "lead_status",
      key: "lead_status",
    },
    {
      title: "Registered At",
      dataIndex: "createdAt",
      key: "createdAt",
      render: (createdAt) => Moment(createdAt).format("DD MMMM YYYY LT"),
    },
    {
      title: "Actions",
      key: "actions",
      render: (text, record) => (
        <Actions
          isAssignedTo={true}
          isDelete={true}
          isEdit={false}
          isLeadStatus={true}
          onClickDelete={() => {
            setDeleteId(record._id);
            setShowDelete(true);
          }}
          onClickLeadStatus={() =>
            setLeadStatusModal({ id: record._id, status: true })
          }
          onClickAssignedTo={() =>
            setAssignModal({ id: record._id, status: true })
          }
        />
      ),
    },
  ];

  const filters = useMemo(
    () => ({
      "Lead Status": leadStatus,
      // "Registered At": [],
    }),
    //eslint-disable-next-line
    [leadStatus, bdModal]
  );

  return (
    <>
      <ListPageLayout
        breadcrumbs={
          <AntdBreadcrumbs
            className="healthsyMasterBreadCrumbs pb-0"
            breadcrumbsList={[
              { text: "Franchise programme", link: "" },
              { text: breadcrumbSecond, link: "" },
            ]}
          />
        }
        addButton={<></>}
        titles={<></>}
        filters={
          <DoctorsFilterOptions
            showSortBy={false}
            limit={pagination.limit}
            sortName={sortName}
            search={search}
            setFilterShow={() => setIsFilterModalVisible(true)}
            onChange={debouncedSearch}
            setLimit={(val) =>
              setPagination((prev) => ({
                ...prev,
                limit: val,
                skip: 0,
                currentPage: 1,
              }))
            }
            downloadExcel={false}
            handleSortClick={handleSortClick}
          />
        }
        tableProps={{
          columns,
          dataSource: records,
        }}
        totalCount={totalCount}
        pagination={pagination}
        onPageChange={(selected) => handlePageChange({ selected })}
        loader={loader}
      >
        {showDelete && (
          <Deletepopup
            handleDelete={handleDelete}
            id={deleteId}
            handleClose={() => setShowDelete(false)}
          />
        )}

        <CommonFIlterModal
          visible={isFilterModalVisible}
          onClose={() => setIsFilterModalVisible(false)}
          onApply={async () => {
            await setSelectedValues(tempSelectedValues);
            await setIsFilterModalVisible(false);
            await setPagination((prev) => ({
              ...prev,
              skip: 0,
              currentPage: 1,
            }));
          }}
          onReset={() => {
            setSelectedValues(emptyFilterValues);
            setTempSelectedValues(emptyFilterValues);
            setPagination((prev) => ({ ...prev, skip: 0, currentPage: 1 }));
            fetchData();
          }}
          filters={filters}
          selectedCategory={selectedCategory}
          setSelectedCategory={setSelectedCategory}
          selectedValues={tempSelectedValues}
          setSelectedValues={setTempSelectedValues}
        />

        {assignModal.status && (
          <AssignedTo
            id={assignModal?.id}
            setAssignModal={setAssignModal}
            setSuccess={setSuccess}
            pathName={pagePath}
          />
        )}

        {success && (
          <SucessModal
            name="BD"
            post="Assigned"
            onClick={successModalClose}
            page={pagePath}
          />
        )}

        {leadStatusModal.status && (
          <LeadStatus
            id={leadStatusModal?.id}
            setLeadStatusModal={setLeadStatusModal}
            setLeadStatusSuccess={setLeadStatusSuccess}
            setLeadStatusConfirmModal={setLeadStatusConfirmModal}
          />
        )}

        {leadStatusConfirmModal.status && (
          <LeadStatusConfirm
            id={leadStatusConfirmModal?.leadType}
            setLeadStatusConfirmModal={setLeadStatusConfirmModal}
            setLeadStatusSuccess={setLeadStatusSuccess}
            leadStatusConfirmModal={leadStatusConfirmModal}
            formType={pagePath}
          />
        )}

        {leadStatussuccess && (
          <SucessModal
            name="Lead Status"
            post="Updated"
            onClick={successModalClose}
            page={pagePath}
          />
        )}

        <ConcernDetailsModal
          isVisible={isModalVisible}
          onClose={() => setIsModalVisible(false)}
          modalData={modalData}
        />

        <SendMailModal
          visible={mailModal.visible}
          to={mailModal.to}
          onCancel={() => setMailModal({ visible: false, to: "" })}
          onSend={handleSendMail}
        />
        <CallModal
          visible={callModal.visible}
          name={capitalizeFirstLetter(callModal.name)}
          mobile={callModal.mobile}
          onCancel={() =>
            setCallModal({ visible: false, name: "", mobile: "" })
          }
        />
      </ListPageLayout>
    </>
  );
}
